// Custom environment variables
export const ENV_MOCK_MODE = import.meta.env.VITE_MOCK_MODE

// Just the base path portion
export const ENV_CCC_CASE_BASE_PATH =
  import.meta.env.VITE_CCC_CASE_BASE_PATH ?? '/'
// Base url = origin + base path
export const ENV_CCC_MAIN_BASE_URL = import.meta.env.VITE_CCC_MAIN_BASE_URL
export const ENV_INTERNAL_BFF_URL =
  import.meta.env.VITE_INTERNAL_BFF_URL ?? 'NOT_FOUND_VITE_INTERNAL_BFF_URL'

export const ENV_ZENDESK_BASE_URL =
  import.meta.env.VITE_ZENDESK_BASE_URL ?? 'NOT_FOUND_VITE_ZENDESK_BASE_URL'
